// @flow
import React, { useState, useCallback } from 'react';

import { navigate } from '../../lib/helpers';
import { tripInspectionFrequencyApi } from '../../lib/api';
import { type TripInspectionFrequency } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/trip-inspection-frequency/';

export default (props: PageProps) => {
  const [data: TripInspectionFrequency, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await tripInspectionFrequencyApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: TripInspectionFrequency) => {
    let id = payload.id;
    if (id) {
      await tripInspectionFrequencyApi.update(payload);
    } else {
      let data = await tripInspectionFrequencyApi.add(payload);
      id = data.id;
    }
    await navigate(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload: TripInspectionFrequency) => {
    if (data.id) {
      await navigate(`${entryPointPath}${data.id}`);
    } else await navigate(`${entryPointPath}`, true);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader:
          'Периодичность проведения предрейсовых/послерейсовых осмотров'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
